var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('img',{attrs:{"alt":"Vue logo","src":require("./assets/ninja-8-bit.jpg"),"width":"200px","height":"200px"}}),_c('HelloWorld',{attrs:{"msg":"<< all your base are belong to taco bell >>"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }